import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
// @ts-ignore
import { phonebook } from "../assets/conf_urls.json"
import { Form, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from '../app/services/auth.service';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';

@Component({
  selector: 'app-phonebook-manager',
  templateUrl: './phonebook-manager.component.html',
  styleUrls: ['./phonebook-manager.component.css']
})
export class PhonebookManagerComponent implements OnInit {
  //custom phonebook
  list_CustomPhonebookFiles = []
  selected_phonebook_file_row = []
  toggle_add_new_phonebook = false;
  toggle_edit_phonebook = false;
  toggle_edit_file_mappings = false;
  form_new_phonebook: FormGroup
  //end
  //forms

  //method
  form_new_contact_method: FormGroup
  form_edit_catalog_card: FormGroup
  form_edit_contact_card: FormGroup
  //
  //phonebook list
  toggle_new_contact_method = false;
  toggle_edit_catalog = false;
  toggle_edit_form = false;
  toggle_list = true;
  list_phonebook_files_data = []
  list_folder_props = []
  list_distinct_system_type = []
  selected_item_contact = ""
  selected_item_folder: any;
  selected_item_folder_row: any;
  show_progressbar = false;
  submit_response = false
  //phonebook mapping
  selected_phonebook_file: any;
  list_selected_folders = [];
  list_all_phonebook_folders = [];
  save_mapping_selected_file: any;
  //
  //phonebook files tree
  obj_tree_query = "select e.Name,r.Protocol,r.`Restrict`,r.DialString,r.Description,r.SystemType from catalog c inner join entry e on c.Id=e.FK_Catalog inner join route r on e.Id = r.FK_Entry"

  //
  constructor(private http: HttpClient,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    private authService: AuthService,
    private loggerService: LoggerService) {
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });

  }

  //### phonebook files list
  //get phonebook files.
  get_phonebook_files_data() {
    let json_object = { "event": "query_all" }
    this.http.post(phonebook.phonebook_management, json_object).subscribe(response_data => {
      this.list_phonebook_files_data = response_data['data']
      this.list_folder_props = response_data['folder_props']

    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)
    })
  }

  //get selected item
  get_selected_phonebook_file(item: any) {
    this.selected_item_contact = item["item"]["props"]

  }

  get_selected_folder(item: any) {
    this.selected_item_folder = item;

  }

  get_selected_folder_data() {
    this.http.post(phonebook.catalog_management, {
      "event": "query_by_name",
      "item": this.selected_item_folder['item']
    }).subscribe(data => {
      this.selected_item_folder_row = data['data'][0]

      this.form_edit_catalog_card = this.fb.group({});
      const Id = new FormControl(this.selected_item_folder_row['Id'], Validators.required)
      const Name = new FormControl(this.selected_item_folder_row['Name'], Validators.required)
      this.form_edit_catalog_card.addControl('Id', Id)
      this.form_edit_catalog_card.addControl('Name', Name)

    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)
    })
  }

  //edit contact card
  edit_contact_card() {
    this.submit_response = false;
    this.http.post(phonebook.entry_management, { "event": "query_distinct_system_type" }).subscribe(data => {
      this.list_distinct_system_type = data['data']
      //Intialize the form
      this.form_edit_contact_card = this.fb.group({});

      //  intialize form controls.
      const fc_name = new FormControl(this.selected_item_contact["Name"], Validators.required)
      const fc_system_type = new FormControl(this.selected_item_contact["SystemType"], Validators.required)
      const fc_protocol = new FormControl(this.selected_item_contact["Protocol"], Validators.required)
      const fc_dialstring = new FormControl(this.selected_item_contact["DialString"], Validators.required)
      const fc_description = new FormControl(this.selected_item_contact["Description"], Validators.required)
      const fc_Id = new FormControl(this.selected_item_contact["Id"], Validators.required)


      this.form_edit_contact_card.addControl('Name', fc_name)
      this.form_edit_contact_card.addControl('SystemType', fc_system_type)
      this.form_edit_contact_card.addControl('Protocol', fc_protocol)
      this.form_edit_contact_card.addControl('Description', fc_description)
      this.form_edit_contact_card.addControl('DialString', fc_dialstring)
      this.form_edit_contact_card.addControl('Id', fc_Id)
    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error);
    })


  }

  edit_new_contact_method() {
    this.http.post(phonebook.entry_management, { "event": "query_distinct_system_type" }).subscribe(data => {
      this.list_distinct_system_type = data['data']
      //Intialize the form
      this.form_new_contact_method = this.fb.group({});

      //initialize form controls.
      const fc_name = new FormControl('', Validators.required)
      const fc_restrict = new FormControl('Norestrict', Validators.required)
      const fc_system_type = new FormControl('', Validators.required)
      const fc_call_type = new FormControl('', Validators.required)
      const fc_protocol = new FormControl('', Validators.required)
      const fc_dialstring = new FormControl('', Validators.required)
      const fc_description = new FormControl('', Validators.required)
      const fc_Id = new FormControl(this.selected_item_folder_row["Id"], Validators.required)
      //add controls
      this.form_new_contact_method.addControl('Name', fc_name)
      this.form_new_contact_method.addControl('Restrict', fc_restrict)
      this.form_new_contact_method.addControl('CallType', fc_call_type)
      this.form_new_contact_method.addControl('SystemType', fc_system_type)
      this.form_new_contact_method.addControl('Protocol', fc_protocol)
      this.form_new_contact_method.addControl('Description', fc_description)
      this.form_new_contact_method.addControl('DialString', fc_dialstring)
      this.form_new_contact_method.addControl('parent_id', fc_Id)
    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)
    })

  }

  submit_form_edit_contact_card() {
    if (this.form_edit_contact_card.valid) {
      this.submit_response = false;
      this.show_progressbar = true;
      //
      this.form_edit_contact_card.value['event'] = 'update_entry_route'
      this.http.post(phonebook.entry_management, this.form_edit_contact_card.value).subscribe(response_data => {
        this.submit_response = true;
        this.show_progressbar = false;

      }, err => {
        this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)
      })
    } else {
      this.submit_response = true;
      this.show_progressbar = false;
    }
  }

  submit_form_edit_catalog_card() {
    if (this.form_edit_catalog_card.valid) {
      this.show_progressbar = true
      this.form_edit_catalog_card.value['event'] = 'update'
      this.http.post(phonebook.catalog_management, this.form_edit_catalog_card.value).subscribe(response_data => {
        if (response_data['status'] == "success") {
          this.show_progressbar = false;
          this.openSnackBar(response_data['message'], response_data['status'])
        } else {
          this.show_progressbar = false;
          this.openSnackBar(response_data['message'], response_data['status'])

        }
      }, err => {
        this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)

      })
    }
  }

  submit_form_new_contact_method() {
    if (this.form_new_contact_method.valid) {
      this.show_progressbar = true
      this.form_new_contact_method.value['event'] = 'create'
      this.http.post(phonebook.entry_management, this.form_new_contact_method.value).subscribe(response_data => {
        if (response_data['status'] == "success") {
          this.show_progressbar = false;
          let rec_id = response_data['data']
          delete this.form_new_contact_method.value['parent_id']
          delete this.form_new_contact_method.value['Name']
          this.form_new_contact_method.value['FK_Entry'] = rec_id
          this.http.post(phonebook.route_management, this.form_new_contact_method.value).subscribe(response_data => {
            this.openSnackBar(response_data['message'], response_data['status'])

          })
        } else {
          this.show_progressbar = false;
          this.openSnackBar(response_data['message'], response_data['status'])

        }
      }, err => {
        this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)

      })
    }
  }

  delete_form_edit_contact_card() {
    if (this.form_edit_contact_card.valid) {
      this.submit_response = false;
      this.show_progressbar = true;
      //
      this.form_edit_contact_card.value['event'] = 'delete_entry_route'
      this.http.post(phonebook.entry_management, this.form_edit_contact_card.value).subscribe(response_data => {
        this.submit_response = true;
        this.show_progressbar = false;

      }, err => {
        this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)
      })
    } else {
      this.submit_response = true;
      this.show_progressbar = false;
    }
  }

  delete_form_edit_catalog_card() {
    if (this.form_edit_catalog_card.valid) {
      this.submit_response = false;
      this.show_progressbar = true;
      //
      this.form_edit_catalog_card.value['event'] = 'delete'
      this.http.post(phonebook.catalog_management, this.form_edit_catalog_card.value).subscribe(response_data => {
        this.submit_response = true;
        this.show_progressbar = false;

      }, err => {
        this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)

      })
    } else {
      this.submit_response = true;
      this.show_progressbar = false;
    }
  }


  //  custom phonebook
  get_all_phonebook_files() {
    this.show_progressbar = true
    this.http.post(phonebook.phonebook_management, { "event": "query_all" }).subscribe(response_data => {
      this.list_CustomPhonebookFiles = response_data['data']
      this.show_progressbar = false
    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)

    })
  }
  get_all_phonebook_files_no_processing() {
    this.http.post(phonebook.phonebook_management, { "event": "query_all" }).subscribe(response_data => {
      this.list_CustomPhonebookFiles = response_data['data']
      this.show_progressbar = false
    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)

    })
  }

  submit_new_phonebook_file() {
    if (this.form_new_phonebook.valid) {
      this.form_new_phonebook.value['event'] = 'create'
      this.http.post(phonebook.phonebook_management, this.form_new_phonebook.value).subscribe(response_data => {
        if (response_data['status'] == 'success') {
          this.openSnackBar(response_data['message'], response_data['status'])
          this.get_all_phonebook_files()
          this.toggle_add_new_phonebook = false;
        } else {
          this.openSnackBar(response_data['message'], response_data['status'])

        }
      }, err => {
        this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)

      })
    }
  }

  submit_edit_phonebook_file(file) {

    let row_id = file['Id']
    let folder_updated_name = $('#update_id_' + row_id).val()


    this.form_new_phonebook.reset()
    this.form_new_phonebook.value['event'] = 'update'
    this.form_new_phonebook.value['Name'] = folder_updated_name
    this.form_new_phonebook.value['Id'] = row_id
    this.http.post(phonebook.phonebook_management, this.form_new_phonebook.value).subscribe(response_data => {
      if (response_data['status'] == 'success') {
        this.openSnackBar(response_data['message'], response_data['status'])
        this.get_all_phonebook_files()
        this.toggle_add_new_phonebook = false;
        this.toggle_edit_phonebook = false;
      } else {
        this.openSnackBar(response_data['message'], response_data['status'])

      }
    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)

    })

  }

  submit_delete_phonebook_file(file) {

    let row_id = file['Id']
    this.form_new_phonebook.reset()
    this.form_new_phonebook.value['event'] = 'delete'
    this.form_new_phonebook.value['Id'] = row_id
    this.http.post(phonebook.phonebook_management, this.form_new_phonebook.value).subscribe(response_data => {
      if (response_data['status'] == 'success') {
        this.openSnackBar(response_data['message'], response_data['status'])
        this.get_all_phonebook_files()
        this.toggle_add_new_phonebook = false;
      } else {
        this.openSnackBar(response_data['message'], response_data['status'])

      }
    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)

    })

  }

  assign_file_row(file: any) {
    this.selected_phonebook_file_row = file
  }

  receiveMessage2($event) {
    var selected_folder = $event
    var flag = 0;
    //case 1
    if (this.list_selected_folders.length == 0) {
      this.list_selected_folders.push(selected_folder)
      return
    }
    //case 2
    Object.keys(this.list_selected_folders).forEach(k => {
      let item_name = this.list_selected_folders[k]['Name']
      if (item_name == selected_folder.Name) {
        flag = 1
        return
      } else {
        flag = 0
      }
    })
    if (flag == 0) {
      this.list_selected_folders.push(selected_folder)
      this.openSnackBar(selected_folder.Name + " was added the list", 'success')
    } else {
      this.openSnackBar(selected_folder.Name + " is already in the list", 'warning')
    }
  }

  //delete mapped folder to file
  delete_folder_from_list(entry) {
    var flag = 0;
    //case 1
    if (this.list_selected_folders.length == 0) {
      return
    }
    //case 2
    Object.keys(this.list_selected_folders).forEach(k => {
      let item_name = this.list_selected_folders[k]['Name']
      if (item_name == entry.Name) {
        flag = 1
        this.list_selected_folders.splice(parseInt(k), 1)
        // remove from database
        let json_object = {
          "event": "delete",
          "phonebook_id": this.save_mapping_selected_file.Id,
          "catalog_id": entry.Id
        }

        let delay = parseInt(k) * 500
        setTimeout(() => {
          this.http.post(phonebook.phonebookcatalog_management, json_object).subscribe(response_data => {
          }, err => {
            this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)
          })

        }, delay)
        //end of remove db.
        this.openSnackBar(entry.Name + " was removed from the list", "success")
        return
      } else {
        flag = 0
      }
    })

  }

  //  phonebook mapping
  get_mapped_folders_to_pb_file(file: any) {
    this.list_all_phonebook_folders = []
    this.list_selected_folders = []
    this.show_progressbar = true
    this.http.post(phonebook.catalog_management, { "event": "queryall" }).subscribe(data => {

      this.list_all_phonebook_folders = data['data']
      this.show_progressbar = false
    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)
    })

    var jobject = {
      "event": "queryall_by_id",
      "id": file.Id
    }
    this.http.post(phonebook.phonebook_task_management, jobject).subscribe(response_data => {
      if (response_data['status'] == "success") {
        this.list_selected_folders = []
        this.list_selected_folders = response_data['data']
      }

    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)
    })
  }

  // save phonebook mapping,
  save_file_folder_mapping() {
    Object.keys(this.list_selected_folders).forEach(index => {
      let folder_id = this.list_selected_folders[index]["Id"]
      let json_object = { "event": "create", "phonebook_id": this.save_mapping_selected_file.Id, "catalog_id": folder_id }

      let delay = parseInt(index) * 500
      setTimeout(() => {
        this.http.post(phonebook.phonebookcatalog_management, json_object).subscribe(response_data => {
        }, err => {
          this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)

        })

      }, delay)

    })
  }
  //publish phonebook file
  publish_phonebook_file(file) {
    let json_object = { "event": "create", "phonebook_id": file.Id }

    this.http.post(phonebook.phonebook_task_management, json_object).subscribe(response_data => {
      if (response_data['status'] == 'success') {
        this.openSnackBar(response_data['message'], response_data['status'])
        this.get_all_phonebook_files()
      }
      else {
        this.openSnackBar(response_data['message'], response_data['status'])

      }
    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)
    })
  }
  delete_publish_phonebook_file(file) {
    let json_object = { "event": "delete", "id": file.id }

    this.http.post(phonebook.phonebook_task_management, json_object).subscribe(response_data => {
      if (response_data['status'] == 'success') {
        this.openSnackBar(response_data['message'], response_data['status'])
        this.get_all_phonebook_files()
      }
      else {
        this.openSnackBar(response_data['message'], response_data['status'])

      }
    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)

    })
  }
  reload_publish_phonebook_file(file) {
    let json_object = { "event": "reload", "id": file.id }

    this.http.post(phonebook.phonebook_task_management, json_object).subscribe(response_data => {
      if (response_data['status'] == 'success') {
        this.openSnackBar(response_data['message'], response_data['status'])
        this.get_all_phonebook_files()
      }
      else {
        this.openSnackBar(response_data['message'], response_data['status'])

      }
    }, err => {
      this.loggerService.log("PhonebookManagerComponent", err.message, Levels.error)

    })
  }


  //  end
  //end ###
  ngOnInit(): void {
    // load custom phonebook list
    this.get_all_phonebook_files()
    //  load phonebook files list
    this.get_phonebook_files_data()
    //auto refresh
    //setInterval(()=>{this.get_all_phonebook_files_no_processing()},3000)

    //  forms
    //Intialize the form
    this.form_edit_contact_card = this.fb.group({
      SystemType: ['', Validators.required],
      Name: ['', Validators.required],
      Protocol: ['', Validators.required],
      Description: ['', Validators.required],
      DialString: ['', Validators.required]
    });
    this.form_edit_catalog_card = this.fb.group({
      Name: ['', Validators.required],
      Id: ['', Validators.required],
    });
    this.form_new_contact_method = this.fb.group({
      SystemType: ['', Validators.required],
      Name: ['', Validators.required],
      CallType: ['', Validators.required],
      Protocol: ['', Validators.required],
      Restrict: ['Norestrict', Validators.required],
      DialString: ['', Validators.required],
      Description: ['', Validators.required],

    });
    this.form_new_phonebook = this.fb.group({
      Name: ['', Validators.required],


    });


  }

}
